import { render, staticRenderFns } from "./h5result.vue?vue&type=template&id=98aaf72e&scoped=true"
import script from "./h5result.vue?vue&type=script&lang=js"
export * from "./h5result.vue?vue&type=script&lang=js"
import style0 from "./h5result.vue?vue&type=style&index=0&id=98aaf72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98aaf72e",
  null
  
)

export default component.exports